import React, { useRef } from 'react';
import classes from "./styles.module.scss";
import Title from '@/ui/Title';
import InsightCard from '../InsightCard';
import PatternChecker from "@/assets/PatternChecker.svg";
import PatternHexagon from "@/assets/PatternHexagon.svg";
import PatternSmall from "@/assets/3_b.svg"
import PatternBig from "@/assets/3_a.svg"
import NavLeft from "@/assets/NavLeft.svg";
import NavRight from "@/assets/NavRight.svg";

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Button from '../Button';

SwiperCore.use([Navigation, Autoplay]);

const Insights = ({title, highlight, color_variant, items}) => {

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const navigation = {
    prevEl: prevRef.current,
    nextEl: nextRef.current,
  };
  const autoplay = {
    delay: 1,
    disableOnInteraction: false,
    stopOnLastSlide: false,
  };
  const breakpoints = {
    500: {
      slidesPerView: 1,
    },
    760: {
      slidesPerView: 1.5,
    },
    880: {
      slidesPerView: 2,
    },
    1100: {
      slidesPerView: 2.5,
    },
    1240: {
      slidesPerView: 3
    }
  };

  return <div className={classes.section}>
    <div className={classes.heading}>
               <PatternBig className={`fill ${color_variant} ${classes.pattern_big}`} />
      <Title title={title} tag="h4" highlight={highlight} variant={color_variant} />
      <div className={`${classes.swiper_nav}`}>
        <div className={`${classes.icon_button} ${classes.hover_effect}`} ref={prevRef}>
          <NavLeft className={`${classes.icon} ${classes.arrow}`}/>
        </div>
        <div className={`${classes.icon_button} ${classes.hover_effect}`} ref={nextRef}>
          <NavRight className={`${classes.icon} ${classes.arrow}`} />
        </div>
      </div>
    </div>
    <div className={classes.list}>
      <Swiper 
        loop 
        effect={"slide"} 
        speed={3000} 
        navigation={navigation} 
        modules={[Navigation]} 
        autoplay={false}
        spaceBetween={10}
        breakpoints={breakpoints}>
        {items?.map((item, index) => (
          <SwiperSlide key={index}>
            <InsightCard item={item}></InsightCard>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    <div className={classes.ctas}>
      <Button icon={true} display="View more" link="/blogs" variant={color_variant}></Button>
    </div>
        <PatternSmall className={`fill ${color_variant} ${classes.pattern_small}`} />
    {/* <PatternChecker className={`fill ${color_variant} ${classes.pattern}`} /> */}
  </div>;
}

export default Insights